<div class="col 6 indicators">
  <label>{{dataSource?.label}}</label>
  <div>
    <span class="value">{{dataSource?.value | format:formatValue}} <br *ngIf="!dataSource?.value" /></span>
    <small *ngIf="dataSource?.offset !== null" class="offset {{dataSource?.offsetStyle}}">
      {{dataSource?.offset | format:formatOffset}}</small>
  </div>
  <div class="goal">{{dataSource?.goalLabel}}<ng-container *ngIf="dataSource?.goalLabel && dataSource?.goal !== null">:</ng-container>
    <span *ngIf="dataSource?.goal !== null" > {{dataSource?.goal | format:formatGoal}}</span></div>
</div>